export const FAILURE = 'failure'
export const NO_ACTIVE_COURSE = 'no-active-course'
export const NOT_ENROLLED = 'not-enrolled'
export const UNDER_13 = 'under13'
export const COURSE_NOT_OPEN = 'course-not-open'
